<template>
  <div class="background">
    <div class="box box-primary">
      <div class="box-header with-border">
        <h3 class="box-title">
          {{ $t('list.background') }}
        </h3>
        <div class="box-tools">
          <template v-if="can([$Permissions.backend.setting.background.store])">
            <router-link
              :to="{name: 'create-background'}"
              class="btn btn-primary btn-sm"
            >
              <i class="fa fa-plus" /> {{ $t('label.newBackground') }}
            </router-link>
          </template>
        </div>
      </div>
      <div class="box-body">
        <div>
          <table
            id="background-table"
            class="table table-hover table-striped table-bordered"
          >
            <thead>
              <tr>
                <th>{{ $t('table.action') }}</th>
                <th>{{ $t('table.createdAt') }}</th>
                <th>{{ $t('table.status') }}</th>
                <th>{{ $t('table.image') }}</th>
                <th>{{ $t('table.titleEn') }}</th>
                <th>{{ $t('table.titleKm') }}</th>
              </tr>
            </thead>
            <tbody />
          </table>
        </div>
      </div>
    </div>
    <template v-if="can([$Permissions.backend.setting.whyUsImage.list])">
      <ImageWhyUsList />
    </template>
  </div>
</template>

<script>
import ImageWhyUsList from '@/views/setting/background/components/ImageWhyUsList'

export default {
  name: 'List',
  components: { ImageWhyUsList },
  metaInfo () {
    return {
      title: this.$t('string.backgroundListing'),
      titleTemplate: '%s | ' + process.env.VUE_APP_NAME
    }
  },
  data () {
    return {
      oTable: null
    }
  },
  watch: {
    '$i18n.locale': function () {
      this.oTable.clear()
      this.oTable.destroy()
      this.oTable = this.refreshTable()
      this.oTable.draw(true)
      this.loadAction()
    }
  },
  methods: {
    deleteBackground (uuid) {
      const self = this
      this.$swal({
        title: self.$t('string.areYouSure?'),
        text: self.$t('string.youWillNotBeAbleToRevertThis!'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: self.$t('string.yesDeleteIt'),
        cancelButtonText: self.$t('button.cancel')
      }).then((result) => {
        if (result.value) {
          this.$axios.post(process.env.VUE_APP_API + '/api/v1/background/delete', {
            background_uuid: uuid
          }).then((response) => {
            if (response.data.code === 1) {
              this.oTable.draw(true)
            }
            this.$swal(
              self.$t('string.deleted!'),
              self.$t('string.theRequestHaveBeenProcessed'),
              'success'
            )
          })
        }
      })
    },
    toggleBackground (uuid) {
      const self = this
      this.$swal({
        title: self.$t('string.areYouSure?'),
        text: self.$t('string.youWillNotBeAbleToRevertThis!'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: self.$t('string.yesToggleIt'),
        cancelButtonText: self.$t('button.cancel')
      }).then((result) => {
        if (result.value) {
          this.$axios.post(process.env.VUE_APP_API + '/api/v1/background/toggle', {
            background_uuid: uuid
          }).then((response) => {
            if (response.data.code === 1) {
              this.oTable.draw(true)
              this.$swal(
                self.$t('string.toggled!'),
                self.$t('string.theRequestHaveBeenProcessed'),
                'success'
              )
            }
          })
        }
      })
    },
    refreshTable () {
      return $('#background-table').DataTable({
        stateSave: true,
        processing: true,
        serverSide: true,
        scrollCollapse: true,
        pageLength: process.env.VUE_APP_PAGE_LENGTH,
        lengthMenu: this.$lengthMenu,
        ajax: {
          method: 'POST',
          url: process.env.VUE_APP_API + '/api/v1/background/datatable',
          error: (xhr) => {
            this.onAccessDenied(xhr)
          }
        },
        columns: [
          {
            data: 'action',
            name: 'action',
            searchable: false,
            orderable: false,
            title: this.$t('table.action'),
            render: (data, type, row) => {
              let action = ''
              if (this.can([this.$Permissions.backend.setting.background.edit])) {
                action += `
                  <button class="btn btn-primary btn-xs btn-edit"
                      data-toggle="tooltip"
                      title="${this.$t('label.edit')}"
                      data-uuid="${row.uuid}">
                    <i class="fa fa-edit"></i>
                  </button> `
              }
              if (this.can([this.$Permissions.backend.setting.background.toggle])) {
                action += `
                   <button class="btn btn-info btn-xs btn-toggle"
                        data-toggle="tooltip"
                        title="${this.$t('label.toggle')}"
                        data-uuid="${row.uuid}">
                     <i class="fa fa-refresh"></i>
                   </button> `
              }
              if (this.can([this.$Permissions.backend.setting.background.delete])) {
                action += `<button class="btn btn-danger btn-xs btn-delete"
                        data-toggle="tooltip"
                        title="${this.$t('label.delete')}"
                        data-uuid="${row.uuid}">
                     <i class="fa fa-trash"></i>
                   </button>`
              }
              if (action !== '') {
                return action
              }
              return this.$t('string.noPermission')
            }
          },
          {
            data: 'created_at',
            name: 'created_at',
            searchable: false,
            title: this.$t('table.createdAt')
          },
          {
            data: 'active',
            name: 'active',
            title: this.$t('table.status'),
            searchable: false,
            render: (data, type, row) => {
              if (row.active) {
                return `<label class="label label-primary">${this.$t('string.active')}</label>`
              } else {
                return `<label class="label label-default">${this.$t('string.inactive')}</label>`
              }
            }
          },
          {
            data: 'image',
            name: 'image',
            title: this.$t('table.image'),
            render: (data, type, row) => {
              if (row.image !== null) {
                return `<img src='${process.env.VUE_APP_API}/${row.image}' width="40px" height="40px" alt="image"/>`
              } else {
                return this.$t('string.na')
              }
            }
          },
          { data: 'title_en', name: 'title_en', title: this.$t('table.titleEn') },
          { data: 'title_km', name: 'title_km', title: this.$t('table.titleKm') }
        ],
        language: {
          url: `/locale/${this.$i18n.locale}.json`
        },
        order: [
          [1, 'desc']
        ]
      })
    },
    loadAction () {
      this.clearEventHandlers([
        '.btn-edit',
        '.btn-toggle',
        '.btn-delete'
      ])
      const self = this
      $(document).on('click', '.btn-edit', function () {
        self.$router.push({
          name: 'edit-background',
          params: { uuid: $(this).attr('data-uuid') }
        })
      })
      $(document).on('click', '.btn-delete', function () {
        self.deleteBackground($(this).attr('data-uuid'))
      })
      $(document).on('click', '.btn-toggle', function () {
        self.toggleBackground($(this).attr('data-uuid'))
      })
    }
  },
  mounted () {
    this.oTable = this.refreshTable()
    this.loadAction()
  },
  beforeDestroy () {
    this.oTable.clear()
    this.oTable.destroy()
  }
}
</script>

<style scoped>

</style>
